import { connect } from 'react-redux';
import { reportHelpfulClickEvent, updateSelectedThumbs, graphHelpfulEvent } from '../../../store/actions/helpful';
import { Events } from '../../../utils/reports/helpful';
import { UPDATE_HELPFUL_COUNT } from '../../../store/actions/types';
import Helpful from './Helpful';

const defaultHelpful = {
    thumbUp: false,
    thumbDown: false,
};

const mapStateToProps = ({ helpful }, { review }) => {
    const { id, encrypted_order_id: encryptedOrderId, helpful_count: helpfulCount = 0 } = review;

    const reviewHelpful = helpful[id];
    const { thumbUp, thumbDown } = reviewHelpful || defaultHelpful;

    return {
        thumbUp,
        thumbDown,
        encryptedOrderId,
        id,
        helpfulCount,
    };
};

const mapDispatchToProps = (dispatch, { review }) => {
    const { id, encrypted_order_id: encryptedOrderId, helpful_count: helpfulCount = 0 } = review;

    return {
        onThumbUpSelected: ({ thumbUp }) => {
            dispatch(
                updateSelectedThumbs({
                    id,
                    thumbUpSelected: thumbUp,
                    thumbDownSelected: false,
                })
            );
            dispatch({
                type: UPDATE_HELPFUL_COUNT,
                id,
                value: thumbUp ? helpfulCount + 1 : helpfulCount - 1,
            });
            dispatch(
                reportHelpfulClickEvent({
                    id,
                    encryptedOrderId,
                    type: Events.clickedOnHelpfulReview,
                    value: thumbUp,
                })
            );
            dispatch(
                graphHelpfulEvent({
                    type: Events.clickedOnHelpfulReview.BigQuery,
                    value: thumbUp,
                })
            );
        },
        onThumbDownSelected: ({ thumbUp, thumbDown }) => {
            if (thumbUp) {
                dispatch({
                    type: UPDATE_HELPFUL_COUNT,
                    id,
                    value: helpfulCount - 1,
                });
            }
            dispatch(
                updateSelectedThumbs({
                    id,
                    thumbUpSelected: false,
                    thumbDownSelected: thumbDown,
                })
            );
            dispatch(
                reportHelpfulClickEvent({
                    id,
                    encryptedOrderId,
                    type: Events.clickedOnNotHelpfulReview,
                    value: thumbDown,
                })
            );
            dispatch(
                graphHelpfulEvent({
                    type: Events.clickedOnNotHelpfulReview.BigQuery,
                    value: thumbDown,
                })
            );
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Helpful);
